webpackJsonp([34041591630459],{

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(3);
	
	var _marketing = __webpack_require__(8);
	
	var _blog = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overview = function (_React$Component) {
	  _inherits(Overview, _React$Component);
	
	  function Overview(props) {
	    _classCallCheck(this, Overview);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Overview.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'DocPage' },
	      _react2.default.createElement(_components.StripeBG, { bg2: "white", style: 'purple' }),
	      _react2.default.createElement(_marketing.Navbar, { className: 'grid-restrain' }),
	      _react2.default.createElement(
	        'section',
	        { className: 'grid-restrain grid-row full-8' },
	        _react2.default.createElement(_blog.DocToc, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'content markdown-doc grid-item' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title' },
	            'Teams'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Your team is composed of projects, starting with a top-level project.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Projects can also be thought of as workspaces. You can use them to organize by any type of unit (team, project, etc) or a mixture of them. '
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'info' },
	              'Keep in mind that each individual project workspace has its own configurable settings for recording, such as selector strategy priorities, so it may be best to have a project per "product" or repository, which may have different frameworks and selector strategies.'
	            ),
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Switching to your team\'s context and creating a new project'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'After you sign-in to your owners account, you\'ll see your team account in the main menu dropdown:'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1528943180/teams/org-account.png', style: { "max-width": "400px" } })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Click on it to switch context to the team\'s project/workspace with a new set of test data:'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1528944025/teams/context-switch.png', style: { "max-width": "400px" } })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'To create a new project, find the  "Manage projects" link in the main menu dropdown:'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1528944124/teams/team-return.png', style: { "max-width": "200px" } })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'On the list of projects, click "+ Add Project" and enter a name.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1528946141/teams/add-project.png', style: { "max-width": "300px" } })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Upon creating it, switch the context by opening the main menu and clicking on the name.  If the background changes, but doesn\'t go to the new projects test directory, hit the "back" button to get back to the main test view.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1528946461/teams/added-project.png', style: { "max-width": "300px" } })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This project is a new set of tests, environments, etc:'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1528945235/teams/new-set.png', style: { "max-width": "400px" } })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Each project/workspace has its own settings, and they are accessible by the cog icon in the main-menu:'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1528945520/teams/proj-cog.png', style: { "max-width": "300px" } })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1528945520/teams/proj-cog-select.png', style: { "max-width": "300px" } })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Overview;
	}(_react2.default.Component);
	
	exports.default = Overview;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-doc-teams-js-cced8c207609b7aa3210.js